import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {HgImportDto} from '../../../../../model/dto/entity/hg-import.dto';
import {HgImportStatusInternalEnum} from '../../../../../model/dto/enum/hg-import-status-internal.enum';

/**
 * Shared header component for the HgImport OBC.
 *
 * Displays:
 *  - Partner name (as a link that emits `onOpenPartner` to the parent)
 *  - Status tag (colored by enum value)
 *  - Created date / Created by
 *
 * Purely presentational — all navigation is delegated back to the parent via
 * the `onOpenPartner` output.
 */
@Component({
    selector: 'hg-import-basic-details',
    templateUrl: './hg-import-basic-details.component.html',
    standalone: false
})
export class HgImportBasicDetailsComponent implements OnInit, OnChanges {

    @Input() importDto: HgImportDto;

    @Output() onOpenPartner: EventEmitter<void> = new EventEmitter<void>();

    initialized: boolean = false;

    /** Exposed to the template for status switch comparisons. */
    protected readonly HgImportStatusInternalEnum = HgImportStatusInternalEnum;

    ngOnInit(): void {
        this.initialized = true;
    }

    ngOnChanges(changes: SimpleChanges): void {
    }

    handleOpenPartner(): void {
        this.onOpenPartner.emit();
    }
}
